var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{ref:"graph",staticClass:"scale-graph",style:({
    maxWidth: _vm.width ? `${_vm.width}px` : undefined,
    maxHeight: _vm.height ? `${_vm.height}px` : undefined
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }